import React, { FC } from 'react';

import { colors } from '../../utils/colors';

export const RedBackground: FC = () => <div style={{ width: '100%', height: '100%', backgroundColor: colors.srgRed }} />;
